import { useEffect, useState } from 'react';
import { fetchRating } from '../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/utils/fetchRating.js';
export const useHotelHasAmadeusRating = ({
  url,
  hotelId,
  ratingSource
}) => {
  const [hasRating, setHasRating] = useState(false);
  useEffect(() => {
    if (!url || !hotelId) {
      setHasRating(false);
      return;
    }
    fetchRating({
      url,
      hotelId,
      page: 1,
      sort: 'latest',
      src: ratingSource
    }).then(rating => {
      setHasRating(!!rating);
    }).catch(() => {
      setHasRating(false);
    });
  }, [url, hotelId, ratingSource]);
  return hasRating;
};